<!--
  프로모션 팝업 컴포넌트
  - 호출 페이지 목록
    - 메인 (Home.vue)
-->
<template>
  <mmp-modal
    v-bind="modalAttrs"
    :class="[classes, {'no_header' : !header, 'no_footer' : !footer}]"
    v-on="listeners"
  >

    <template
      v-slot:header
      v-if="header"
    >
      <div v-dompurify-html="title"/>
      <button type="button" class="btn_close" @click="$emit('close')">
        <span class="blind">팝업 닫기</span>
      </button>
    </template>

    <template v-slot:content>
      <div class="promo_modal_content">
        <div class="inner">

          <!-- 팝업 닫기 버튼 -->
          <button
            class="btn_close_popup"
            @click="closePopup"
          >팝업 닫기</button>
          <!-- // 팝업 닫기 버튼 -->

          <div class="wrap_swiper">
            <div ref="promoModalSwiper" class="swiper-container">
              <div class="swiper-wrapper">
                <div
                  v-for="(item, index) in promoPopupData"
                  :key="index"
                  class="swiper-slide"
                >
                  <span class="txt">{{ item.title }}</span>
                  <div class="banner">
                    <img :src="isDesktop ? item.img.pc : item.img.mo">
                  </div>

                  <!-- 상세보기 버튼 -->
                  <button
                    class="btn_go_detail"
                    @click="goDetail(item)"
                  >상세보기</button>
                  <!-- // 상세보기 버튼 -->

                </div>
              </div>
            </div>

            <!-- swiper pagination -->
            <div v-show="promoPopupData.length > 1" class="swiper_pagination" />
            <!-- // swiepr pagination -->

            <!-- swiper navigation -->
            <div v-show="isDesktop && promoPopupData.length > 1" class="swiper_navigation">
              <div class="swiper-button-prev" />
              <div class="swiper-button-next" />
            </div>
            <!-- // swiper navigation -->

          </div>
          <div class="wrap_button">
            <div class="inner">
              <div class="check_box">
                <input
                  id="checkPromo" v-model="checkPromo" name="checkPromo"
                  type="checkbox" class="checkbox"
                >
                <label for="checkPromo" class="hidden">
                  <span>오늘 하루 안 보기</span>
                </label>
              </div>
              <button
                class="btn_promo_footer"
                @click="hideForToday"
              >오늘 하루 안 보기</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template
      v-slot:footer
      v-if="footer"
    >
      <div class="wrap_footer_btn single">
        <button class="btn__box-blue-md" @click="$emit('close')">확인</button>
      </div>
    </template>

  </mmp-modal>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'PromotionModal',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    fullModal: {
      type: Boolean,
      default: true
    },
    useDefaultHeader: {
      type: Boolean,
      default: false
    },
    useDefaultFooter: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: true
    },
    // 푸터 자체 노출 여부
    footer: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    classes: {
      type: Array,
      default: null,
      required: false
    },
    promoPopupData: {
      type: Array,
      default: null,
      required: true
    }
  },
  data () {
    return {
      viewportWidth: 0, // 브라우저 뷰포트 width
      viewportHeight: 0, // 브라우저 뷰포트 height
      swiper: {
        instance: null,
        option: {
          slidesPerView: 1,
          spaceBetween: 0,
          responsive: true,
          pagination: {
            el: '.promo_modal_content .swiper_pagination',
            clickable: true
          },
          navigation: {
            prevEl: '.promo_modal_content .swiper-button-prev',
            nextEl: '.promo_modal_content .swiper-button-next'
          }
        }
      },
      // 프로모션 팝업 데이터
      /* promoPopupData: [
        {
          title: '말문이 터지는 아웃라우드에서 진짜 말하기 실력을 키워봐!',
          img: {
            pc: '/static/images/@temp/promotion_popup_pc.jpg',
            mo: '/static/images/@temp/promotion_popup_mo.jpg'
          },
          link: '#'
        },
        {
          title: '멀캠아 여름휴가를 부탁해',
          img: {
            pc: '/static/images/@temp/promotion_popup_pc.jpg',
            mo: '/static/images/@temp/promotion_popup_mo.jpg'
          },
          link: '#'
        },
        {
          title: '빠른 퇴근을 부르는 업무 단축키 모음',
          img: {
            pc: '/static/images/@temp/promotion_popup_pc.jpg',
            mo: '/static/images/@temp/promotion_popup_mo.jpg'
          },
          link: '#'
        },
        {
          title: '나에게 딱 맞는 파이썬 강의는? 수강 유형 테스트 바로가기',
          img: {
            pc: '/static/images/@temp/promotion_popup_pc.jpg',
            mo: '/static/images/@temp/promotion_popup_mo.jpg'
          },
          link: '#'
        },
        {
          title: '5인 이상 단체할인',
          img: {
            pc: '/static/images/@temp/promotion_popup_pc.jpg',
            mo: '/static/images/@temp/promotion_popup_mo.jpg'
          },
          link: '#'
        }
      ], */
      checkPromo: false,
      hideForTodayTime: 200
    }
  },
  computed: {
    // 현재 디바이스 viewport width 가 데스크탑 사이즈인 경우 true
    isDesktop () {
      return window.vue.getStore('homeInfo').state.isDeskTopMode
    },
    isValidParam () {
      return true
    },
    modalAttrs () {
      return {
        ...this.componentAttrs,
        useDefaultHeader: this.useDefaultHeader,
        useDefaultFooter: this.useDefaultFooter,
        fullModal: this.fullModal,
        title: this.title
      }
    }
  },
  watch: {
    checkPromo (newValue, oldValue) {
      if (newValue) {
        setTimeout(() => {
          this.hideForToday()
        }, this.hideForTodayTime)
      }
    }
  },
  mounted () {
    this.initPromoSwiper()
  },
  beforeDestroy () {
    this.destroyPromoSwiper()
  },
  methods: {
    // 필터 UI 스와이퍼 설정
    initPromoSwiper () {
      this.$nextTick(function () {
        const swiperContainer = this.$refs.promoModalSwiper
        if (swiperContainer) {
          setTimeout(() => {
            this.swiper.instance = new Swiper(swiperContainer, this.swiper.option)
          }, 400)
        }
      })
    },
    // 필터 UI 스와이퍼 해제
    destroyPromoSwiper () {
      const swiperInstance = this.swiper.instance

      if (swiperInstance !== null) {
        swiperInstance.destroy()
        this.swiper.instance = null
      }
    },
    // 오늘 하루 안보기
    setDisabledPromotion () {
      // NOTE: 오늘 하루 안보기 처리
      this.$emit('close')
    },
    // 팝업 닫기
    closePopup () {
      this.$emit('close')
    },
    // 상세보기 이동
    goDetail (item) {
      this.goPotltLink(item)
    },
    // 오늘 하루 안 보기
    hideForToday () {
      this.checkPromo = true

      const hideUntil = new Date().getTime() + 24 * 60 * 60 * 1000 // 24시간
      const hidePopupData = {
        hidePopupForToday: true,
        hideUntil: hideUntil
      }

      setTimeout(() => {
        localStorage.setItem('hidePopupData', JSON.stringify(hidePopupData))
        this.setDisabledPromotion()
      }, this.hideForTodayTime)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/modal/PromotionModal.vue